export default {
    winter: {
        banners: [
            // arranged according priority
        ],

        infoIcons: [
            // arranged according priority
            {
                // balcon / terrasse
                ids: new Set(["52"]),
                svgName: "animals",
                name: "animal",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                ids: new Set([
                    "338",
                    "337",
                    "336",
                    "335",
                    "334",
                    "333",
                    "332",
                    "331",
                    "330",
                    "329",
                    "328",
                    "327",
                    "326",
                    "325",
                    "324",
                    "323",
                    "322",
                    "321",
                    "320",
                    "319",
                ]),
                svgName: "bed",
                name: "sleepingRooms",
                conflictingCriterias: ["rooms"],
                combinator: "OR",
            },
            // {
            //     ids: new Set([
            //         "354",
            //         "353",
            //         "352",
            //         "351",
            //         "350",
            //         "349",
            //         "348",
            //         "347",
            //         "346",
            //         "345",
            //         "344",
            //         "343",
            //         "342",
            //         "341",
            //         "340",
            //         "339",
            //     ]),
            //     svgName: "bed",
            //     name: "rooms",
            //     conflictingCriterias: ["sleepingRooms"],
            //     combinator: "OR",
            // },
            // {
            //     // balcon / terrasse
            //     ids: new Set(["29"]),
            //     svgName: "cart",
            //     name: "terrasse",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
        ],

        inPrivateKitchen: [
            {
                // equiped kitchen
                ids: new Set(["705"]),
                svgName: "check",
                name: "equipedKitchen",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // separate kitchen
                ids: new Set(["757"]),
                svgName: "check",
                name: "separateKitchen",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // dishwasher
                ids: new Set(["22"]),
                svgName: "check",
                name: "dishwasher",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // fridge
                ids: new Set(["756"]),
                svgName: "check",
                name: "fridge",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // hob
                ids: new Set(["759"]),
                svgName: "check",
                name: "hob",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // oven
                ids: new Set(["750"]),
                svgName: "check",
                name: "oven",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // microwave
                ids: new Set(["758"]),
                svgName: "check",
                name: "microwave",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // coffee machine
                ids: new Set(["752"]),
                svgName: "check",
                name: "coffeeMachine",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // kettle
                ids: new Set(["754"]),
                svgName: "check",
                name: "kettle",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // toaster
                ids: new Set(["755"]),
                svgName: "check",
                name: "toaster",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        inPrivateBathroom: [
            {
                // shower
                ids: new Set(["715"]),
                svgName: "check",
                name: "shower",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // bathtub
                ids: new Set(["714"]),
                svgName: "check",
                name: "bathtub",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        inPrivateServices: [
            {
                //
                ids: new Set(["748"]),
                svgName: "check",
                name: "shower",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                //
                ids: new Set(["45"]),
                svgName: "check",
                name: "bathtub",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                //
                ids: new Set(["801"]),
                svgName: "check",
                name: "shower",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                //
                ids: new Set(["51"]),
                svgName: "check",
                name: "bathtub",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        appartementEquipments: [
            // arranged according priority
            // {
            //     // rooms
            //     ids: new Set([
            //         "354",
            //         "353",
            //         "352",
            //         "351",
            //         "350",
            //         "349",
            //         "348",
            //         "347",
            //         "346",
            //         "345",
            //         "344",
            //         "343",
            //         "342",
            //         "341",
            //         "340",
            //         "339",
            //     ]),
            //     svgName: "check",
            //     name: "rooms",
            //     conflictingCriterias: ["sleepingRooms"],
            //     combinator: "OR",
            // },
            {
                // sleeping rooms
                ids: new Set([
                    "338",
                    "337",
                    "336",
                    "335",
                    "334",
                    "333",
                    "332",
                    "331",
                    "330",
                    "329",
                    "328",
                    "327",
                    "326",
                    "325",
                    "324",
                    "323",
                    "322",
                    "321",
                    "320",
                    "319",
                ]),
                svgName: "check",
                name: "sleepingRooms",
                conflictingCriterias: ["rooms"],
                combinator: "OR",
            },
            {
                // double beds
                ids: new Set(["985", "982", "983", "762", "741"]),
                svgName: "check",
                name: "doubleBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // single beds
                ids: new Set(["987", "986", "988", "984", "767", "766", "765", "764", "763", "742"]),
                svgName: "check",
                name: "singleBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // bunk beds
                ids: new Set(["769", "768", "743"]),
                svgName: "check",
                name: "bunkBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // double sofa bed
                ids: new Set(["747"]),
                svgName: "check",
                name: "doubleSofaBed",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // sofa beds
                ids: new Set(["771", "745"]),
                svgName: "check",
                name: "sofaBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // trundle beds
                ids: new Set(["744"]),
                svgName: "check",
                name: "sofaBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // baby cot
                ids: new Set(["46"]),
                svgName: "check",
                name: "babyCot",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // sofa
                ids: new Set(["746"]),
                svgName: "check",
                name: "sofa",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // balcon / terrasse
                ids: new Set(["29"]),
                svgName: "check",
                name: "terrasse",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // balconies
                ids: new Set(["773"]),
                svgName: "check",
                name: "balcons",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // balcony
                ids: new Set(["739"]),
                svgName: "check",
                name: "balcony",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // terrasse
                ids: new Set(["738"]),
                svgName: "check",
                name: "terrasse",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // mezzanine
                ids: new Set(["761"]),
                svgName: "check",
                name: "mezzanine",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // ground floor
                ids: new Set(["30"]),
                svgName: "check",
                name: "groundFloor",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // wifi / internet
                ids: new Set(["55"]),
                svgName: "check",
                name: "wifi",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // television
                ids: new Set(["27"]),
                svgName: "check",
                name: "television",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // washing machine
                ids: new Set(["23"]),
                svgName: "check",
                name: "lave-linge",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // tumble dryer
                ids: new Set(["803"]),
                svgName: "check",
                name: "tumbleDryer",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // baby set
                ids: new Set(["47"]),
                svgName: "check",
                name: "babySet",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // maintenance kit
                ids: new Set(["799"]),
                svgName: "check",
                name: "maintenanceKit",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // barbecue
                ids: new Set(["48"]),
                svgName: "check",
                name: "barbecue",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // ac
                ids: new Set(["25"]),
                svgName: "check",
                name: "ac",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // separate toilets
                ids: new Set(["981"]),
                svgName: "check",
                name: "separateToilets",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // personsWithReducedMobility
                ids: new Set(["31"]),
                svgName: "check",
                name: "personsWithReducedMobility",
                conflictingCriterias: [""],
                combinator: "OR",
            },
        ],

        advantages: [
            // arranged according priority
            {
                // skipass on arrival
                ids: new Set(["700"]),
                svgName: "smile-and-pass",
                name: "skipassOnArrival",
                conflictingCriterias: [],
                combinator: "OR",
            },
            // { // services/equipment
            //     ids: new Set(['32', '703']),
            //     svgName: 'skishop',
            //     name: "skishopInResidence",
            //     conflictingCriterias: ['smileAndPass'],
            //     combinator: "OR",
            // },
            {
                // distance to slopes
                ids: new Set(["291", "716", "717", "285", "822", "286", "287"]),
                svgName: "materiel",
                name: "distance-to-slopes",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // distance to ski school
                ids: new Set(["365", "720", "721", "359", "360", "361"]),
                svgName: "skishop",
                name: "distance-to-ski-school",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // distance to center
                ids: new Set(["305", "718", "719", "299", "300", "301"]),
                svgName: "distanceCenter",
                name: "distance-to-center",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // elevator
                ids: new Set(["798"]),
                svgName: "lift",
                name: "lift",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // pets allowed
                ids: new Set(["52"]),
                svgName: "animals",
                name: "petsAllowed",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // wifi / internet
                ids: new Set(["55"]),
                svgName: "wifi",
                name: "wifi",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // personsWithReducedMobility
                ids: new Set(["31"]),
                svgName: "disabled",
                name: "personsWithReducedMobility",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // parking
                ids: new Set(["36", "37"]),
                svgName: "parking",
                name: "parking",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // pool
                ids: new Set(["74", "76"]),
                svgName: "pool",
                name: "privateExternalPool",
                conflictingCriterias: ["pool", "privateInternalPool"],
                combinator: "AND",
            },
            {
                // pool
                ids: new Set(["75", "76"]),
                svgName: "pool",
                name: "privateInternalPool",
                conflictingCriterias: ["pool", "privateExternalPool"],
                combinator: "AND",
            },
            {
                // pool
                ids: new Set(["74", "75", "76"]),
                svgName: "pool",
                name: "pool",
                conflictingCriterias: ["privateExternalPool", "privateInternalPool"],
                combinator: "OR",
            },
            {
                // ski locker
                ids: new Set(["800"]),
                svgName: "ski-locker",
                name: "skiLocker",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // catering service
                ids: new Set(["60", "61", "63", "64", "65", "67"]),
                svgName: "cateringService",
                name: "cateringService",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // hammam
                ids: new Set(["69"]),
                svgName: "hammam",
                name: "hammam",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // hot tub
                ids: new Set(["732"]),
                svgName: "bath",
                name: "hotTub",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // fitness room
                ids: new Set(["733"]),
                svgName: "spa",
                name: "fitnessRoom",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // sauna
                ids: new Set(["70"]),
                svgName: "sauna",
                name: "sauna",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // spa
                ids: new Set(["71"]),
                svgName: "spa",
                name: "spa",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // distance to shops
                ids: new Set(["312", "807", "808", "306", "307", "308"]),
                svgName: "commerce",
                name: "distanceToShops",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // kids club
                ids: new Set(["979"]),
                svgName: "kidsClub",
                name: "kidsClub",
                conflictingCriterias: [],
                combinator: "OR",
            },
            // {
            //     // television
            //     ids: new Set(["27"]),
            //     svgName: "tv",
            //     name: "television",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            {
                // 18 - 35 years old
                ids: new Set(["815"]),
                svgName: "youngPeople",
                name: "18_-_35_years_old",
                conflictingCriterias: [],
                combinator: "OR",
            },
            // {
            //     // luggage storage
            //     ids: new Set(["980"]),
            //     svgName: "baggage",
            //     name: "luggageStorage",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            // {
            //     // towels
            //     ids: new Set(["45"]),
            //     svgName: "towel",
            //     name: "towels",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            // {
            //     // beds on arrival
            //     ids: new Set(["801"]),
            //     svgName: "bed",
            //     name: "bedsMadeOnArrival",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            // {
            //     // end of stay cleaning
            //     ids: new Set(["51"]),
            //     svgName: "cleaning",
            //     name: "endOfStayCleaning",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
        ],
    },
    summer: {
        banners: [
            // arranged according priority
        ],

        infoIcons: [
            // arranged according priority
            {
                ids: new Set([
                    "338",
                    "337",
                    "336",
                    "335",
                    "334",
                    "333",
                    "332",
                    "331",
                    "330",
                    "329",
                    "328",
                    "327",
                    "326",
                    "325",
                    "324",
                    "323",
                    "322",
                    "321",
                    "320",
                    "319",
                ]),
                svgName: "bed",
                name: "sleepingRooms",
                conflictingCriterias: ["rooms"],
                combinator: "OR",
            },
            // {
            //     ids: new Set([
            //         "354",
            //         "353",
            //         "352",
            //         "351",
            //         "350",
            //         "349",
            //         "348",
            //         "347",
            //         "346",
            //         "345",
            //         "344",
            //         "343",
            //         "342",
            //         "341",
            //         "340",
            //         "339",
            //     ]),
            //     svgName: "bed",
            //     name: "rooms",
            //     conflictingCriterias: ["sleepingRooms"],
            //     combinator: "OR",
            // },
            // {
            //     // balcon / terrasse
            //     ids: new Set(["29"]),
            //     svgName: "cart",
            //     name: "terrasse",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            {
                // animal / terrasse
                ids: new Set(["52"]),
                svgName: "animals",
                name: "animal",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        inPrivateKitchen: [
            {
                // equiped kitchen
                ids: new Set(["705"]),
                svgName: "check",
                name: "equipedKitchen",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // separate kitchen
                ids: new Set(["757"]),
                svgName: "check",
                name: "separateKitchen",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // dishwasher
                ids: new Set(["22"]),
                svgName: "check",
                name: "dishwasher",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // fridge
                ids: new Set(["756"]),
                svgName: "check",
                name: "fridge",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // hob
                ids: new Set(["759"]),
                svgName: "check",
                name: "hob",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // oven
                ids: new Set(["750"]),
                svgName: "check",
                name: "oven",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // microwave
                ids: new Set(["758"]),
                svgName: "check",
                name: "microwave",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // coffee machine
                ids: new Set(["752"]),
                svgName: "check",
                name: "coffeeMachine",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // kettle
                ids: new Set(["754"]),
                svgName: "check",
                name: "kettle",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // toaster
                ids: new Set(["755"]),
                svgName: "check",
                name: "toaster",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        inPrivateBathroom: [
            {
                // shower
                ids: new Set(["715"]),
                svgName: "check",
                name: "shower",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // bathtub
                ids: new Set(["714"]),
                svgName: "check",
                name: "bathtub",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        inPrivateServices: [
            {
                //
                ids: new Set(["748"]),
                svgName: "check",
                name: "shower",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                //
                ids: new Set(["45"]),
                svgName: "check",
                name: "bathtub",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                //
                ids: new Set(["801"]),
                svgName: "check",
                name: "shower",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                //
                ids: new Set(["51"]),
                svgName: "check",
                name: "bathtub",
                conflictingCriterias: [],
                combinator: "OR",
            },
        ],

        appartementEquipments: [
            // arranged according priority
            // {
            //     // rooms
            //     ids: new Set([
            //         "354",
            //         "353",
            //         "352",
            //         "351",
            //         "350",
            //         "349",
            //         "348",
            //         "347",
            //         "346",
            //         "345",
            //         "344",
            //         "343",
            //         "342",
            //         "341",
            //         "340",
            //         "339",
            //     ]),
            //     svgName: "check",
            //     name: "rooms",
            //     conflictingCriterias: ["sleepingRooms"],
            //     combinator: "OR",
            // },
            {
                // sleeping rooms
                ids: new Set([
                    "338",
                    "337",
                    "336",
                    "335",
                    "334",
                    "333",
                    "332",
                    "331",
                    "330",
                    "329",
                    "328",
                    "327",
                    "326",
                    "325",
                    "324",
                    "323",
                    "322",
                    "321",
                    "320",
                    "319",
                ]),
                svgName: "check",
                name: "sleepingRooms",
                conflictingCriterias: ["rooms"],
                combinator: "OR",
            },
            {
                // double beds
                ids: new Set(["985", "982", "983", "762", "741"]),
                svgName: "check",
                name: "doubleBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // single beds
                ids: new Set(["987", "986", "988", "984", "767", "766", "765", "764", "763", "742"]),
                svgName: "check",
                name: "singleBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // bunk beds
                ids: new Set(["769", "768", "743"]),
                svgName: "check",
                name: "bunkBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // double sofa bed
                ids: new Set(["747"]),
                svgName: "check",
                name: "doubleSofaBed",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // sofa beds
                ids: new Set(["771", "745"]),
                svgName: "check",
                name: "sofaBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // trundle beds
                ids: new Set(["744"]),
                svgName: "check",
                name: "sofaBeds",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // baby cot
                ids: new Set(["46"]),
                svgName: "check",
                name: "babyCot",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // sofa
                ids: new Set(["746"]),
                svgName: "check",
                name: "sofa",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // balcon / terrasse
                ids: new Set(["29"]),
                svgName: "check",
                name: "terrasse",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // balconies
                ids: new Set(["773"]),
                svgName: "check",
                name: "balcons",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // balcony
                ids: new Set(["739"]),
                svgName: "check",
                name: "balcony",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // terrasse
                ids: new Set(["738"]),
                svgName: "check",
                name: "terrasse",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // mezzanine
                ids: new Set(["761"]),
                svgName: "check",
                name: "mezzanine",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // ground floor
                ids: new Set(["30"]),
                svgName: "check",
                name: "groundFloor",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // wifi / internet
                ids: new Set(["55"]),
                svgName: "check",
                name: "wifi",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // television
                ids: new Set(["27"]),
                svgName: "check",
                name: "television",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // washing machine
                ids: new Set(["23"]),
                svgName: "check",
                name: "lave-linge",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // tumble dryer
                ids: new Set(["803"]),
                svgName: "check",
                name: "tumbleDryer",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // baby set
                ids: new Set(["47"]),
                svgName: "check",
                name: "babySet",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // maintenance kit
                ids: new Set(["799"]),
                svgName: "check",
                name: "maintenanceKit",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // barbecue
                ids: new Set(["48"]),
                svgName: "check",
                name: "barbecue",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // ac
                ids: new Set(["25"]),
                svgName: "check",
                name: "ac",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // separate toilets
                ids: new Set(["981"]),
                svgName: "check",
                name: "separateToilets",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // personsWithReducedMobility
                ids: new Set(["31"]),
                svgName: "check",
                name: "personsWithReducedMobility",
                conflictingCriterias: [""],
                combinator: "OR",
            },
        ],

        advantages: [
            // arranged according priority

            // arranged according priority
            {
                // skipass on arrival
                ids: new Set(["700"]),
                svgName: "smile-and-pass",
                name: "skipassOnArrival",
                conflictingCriterias: [],
                combinator: "OR",
            },
            // { // services/equipment
            //     ids: new Set(['32', '703']),
            //     svgName: 'skishop',
            //     name: "skishopInResidence",
            //     conflictingCriterias: ['smileAndPass'],
            //     combinator: "OR",
            // },
            {
                // distance to slopes
                ids: new Set(["291", "716", "717", "285", "822", "286", "287"]),
                svgName: "materiel",
                name: "distance-to-slopes",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // distance to ski school
                ids: new Set(["365", "720", "721", "359", "360", "361"]),
                svgName: "skishop",
                name: "distance-to-ski-school",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // distance to center
                ids: new Set(["305", "718", "719", "299", "300", "301"]),
                svgName: "distanceCenter",
                name: "distance-to-center",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // elevator
                ids: new Set(["798"]),
                svgName: "lift",
                name: "lift",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // pets allowed
                ids: new Set(["52"]),
                svgName: "animals",
                name: "petsAllowed",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // wifi / internet
                ids: new Set(["55"]),
                svgName: "wifi",
                name: "wifi",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // personsWithReducedMobility
                ids: new Set(["31"]),
                svgName: "disabled",
                name: "personsWithReducedMobility",
                conflictingCriterias: [""],
                combinator: "OR",
            },
            {
                // parking
                ids: new Set(["36", "37"]),
                svgName: "parking",
                name: "parking",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // pool
                ids: new Set(["74", "76"]),
                svgName: "pool",
                name: "privateExternalPool",
                conflictingCriterias: ["pool", "privateInternalPool"],
                combinator: "AND",
            },
            {
                // pool
                ids: new Set(["75", "76"]),
                svgName: "pool",
                name: "privateInternalPool",
                conflictingCriterias: ["pool", "privateExternalPool"],
                combinator: "AND",
            },
            {
                // pool
                ids: new Set(["74", "75", "76"]),
                svgName: "pool",
                name: "pool",
                conflictingCriterias: ["privateExternalPool", "privateInternalPool"],
                combinator: "OR",
            },
            {
                // ski locker
                ids: new Set(["800"]),
                svgName: "ski-locker",
                name: "skiLocker",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // catering service
                ids: new Set(["60", "61", "63", "64", "65", "67"]),
                svgName: "cateringService",
                name: "cateringService",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // hammam
                ids: new Set(["69"]),
                svgName: "hammam",
                name: "hammam",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // hot tub
                ids: new Set(["732"]),
                svgName: "bath",
                name: "hotTub",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // fitness room
                ids: new Set(["733"]),
                svgName: "spa",
                name: "fitnessRoom",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // sauna
                ids: new Set(["70"]),
                svgName: "sauna",
                name: "sauna",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // spa
                ids: new Set(["71"]),
                svgName: "spa",
                name: "spa",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // distance to shops
                ids: new Set(["312", "807", "808", "306", "307", "308"]),
                svgName: "commerce",
                name: "distanceToShops",
                conflictingCriterias: [],
                combinator: "OR",
            },
            {
                // kids club
                ids: new Set(["979"]),
                svgName: "kidsClub",
                name: "kidsClub",
                conflictingCriterias: [],
                combinator: "OR",
            },
            // {
            //     // television
            //     ids: new Set(["27"]),
            //     svgName: "tv",
            //     name: "television",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            {
                // 18 - 35 years old
                ids: new Set(["815"]),
                svgName: "youngPeople",
                name: "18_-_35_years_old",
                conflictingCriterias: [],
                combinator: "OR",
            },
            // {
            //     // luggage storage
            //     ids: new Set(["980"]),
            //     svgName: "baggage",
            //     name: "luggageStorage",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            // {
            //     // towels
            //     ids: new Set(["45"]),
            //     svgName: "towel",
            //     name: "towels",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            // {
            //     // beds on arrival
            //     ids: new Set(["801"]),
            //     svgName: "bed",
            //     name: "bedsMadeOnArrival",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
            // {
            //     // end of stay cleaning
            //     ids: new Set(["51"]),
            //     svgName: "cleaning",
            //     name: "endOfStayCleaning",
            //     conflictingCriterias: [],
            //     combinator: "OR",
            // },
        ],
    },
};
